<script setup lang="ts">
export interface AppDotsProps {
  numberOfDots?: number;
  activeDotIndex?: number;
  disabledDots?: number;
}

const props = withDefaults(defineProps<AppDotsProps>(), {
  numberOfDots: 3,
  disabledDots: 0,
});

interface AppDotsEmits {
  (eventName: 'dot-clicked', index: number): void;
}

const emit = defineEmits<AppDotsEmits>();
</script>

<template>
  <div class="app-dots">
    <div
      v-for="dotIndex in props.numberOfDots"
      :key="dotIndex"
      class="dot"
      :class="{
        active: dotIndex === props.activeDotIndex,
        disabled: dotIndex > props.numberOfDots - props.disabledDots,
      }"
      @click="emit('dot-clicked', dotIndex)"
    />
  </div>
</template>

<style scoped lang="scss">
.app-dots {
  padding: var(--spacing-8) 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  .dot {
    border: none;
    width: var(--spacing-8);
    height: var(--spacing-8);
    opacity: 0.25;
    border-radius: 50%;
    margin: 0 var(--spacing-4);
    cursor: pointer;
    outline: none;
    background-color: var(--color-white);

    &.active {
      opacity: 1;
      width: 0.75rem;
      height: 0.75rem;
      background-color: var(--color-white);
    }

    &.disabled {
      display: none;
    }
  }
}
</style>
